import React from 'react'
import { UserList } from '../../components'

const Userlist = () => {
  return (
    <div>
      <UserList />
    </div>
  )
}

export default Userlist